import { render } from "./FazendasDash.vue?vue&type=template&id=0030a063&scoped=true"
import script from "./FazendasDash.vue?vue&type=script&lang=js"
export * from "./FazendasDash.vue?vue&type=script&lang=js"

import "./FazendasDash.vue?vue&type=style&index=0&id=0030a063&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0030a063"]])

export default __exports__